import type { IxcCorpactionsCaadminV1ActionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const CORPACT_CA_ADMIN_ACTION_BASE_PATH = getResolvedPath('/clearing/operations/ca/action');

export const getCorpactCaAdminActionPath: EntityPathBuilder<IxcCorpactionsCaadminV1ActionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CORPACT_CA_ADMIN_ACTION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.actionId) {
        return undefined;
      }

      return getResolvedPath(`${CORPACT_CA_ADMIN_ACTION_BASE_PATH}/$actionId`, context.keys);
    }
  }
};

export function getCorpactCaAdminActionDetailPath(actionId: string | undefined, versionId?: string | undefined) {
  if (!actionId) {
    return undefined;
  }

  const base = getCorpactCaAdminActionPath({ kind: 'detail', keys: { actionId } });
  if (!base) {
    return undefined;
  }

  if (!versionId) {
    return base;
  }

  return `${base}?versionId=${versionId}`;
}
